"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _DOMAIN = 'remote-items/';
exports.default = {
  GET_LIST_INIT: _DOMAIN + 'GET_LIST_INIT',
  GET_LIST_SUCCESS: _DOMAIN + 'GET_LIST_SUCCESS',
  GET_LIST_FAILURE: _DOMAIN + 'GET_LIST_FAILURE',
  RELOAD_INIT: _DOMAIN + 'RELOAD_INIT',
  RELOAD_SUCCESS: _DOMAIN + 'RELOAD_SUCCESS',
  RELOAD_FAILURE: _DOMAIN + 'RELOAD_FAILURE',
  ADD_INIT: _DOMAIN + 'ADD_INIT',
  ADD_SUCCESS: _DOMAIN + 'ADD_SUCCESS',
  ADD_FAILURE: _DOMAIN + 'ADD_FAILURE',
  EDIT_INIT: _DOMAIN + 'EDIT_INIT',
  EDIT_SUCCESS: _DOMAIN + 'EDIT_SUCCESS',
  EDIT_FAILURE: _DOMAIN + 'EDIT_FAILURE',
  REMOVE_INIT: _DOMAIN + 'REMOVE_INIT',
  REMOVE_SUCCESS: _DOMAIN + 'REMOVE_SUCCESS',
  REMOVE_FAILURE: _DOMAIN + 'REMOVE_FAILURE',
  DETACH_INIT: _DOMAIN + 'DETACH_INIT',
  DETACH_SUCCESS: _DOMAIN + 'DETACH_SUCCESS',
  DETACH_FAILURE: _DOMAIN + 'DETACH_FAILURE',
  CONTRIBUTE_INIT: _DOMAIN + 'CONTRIBUTE_INIT',
  CONTRIBUTE_SUCCESS: _DOMAIN + 'CONTRIBUTE_SUCCESS',
  CONTRIBUTE_FAILURE: _DOMAIN + 'CONTRIBUTE_FAILURE',
  RESUBMIT_INIT: _DOMAIN + 'RESUBMIT_INIT',
  RESUBMIT_SUCCESS: _DOMAIN + 'RESUBMIT_SUCCESS',
  RESUBMIT_FAILURE: _DOMAIN + 'RESUBMIT_FAILURE',
  UPDATE_OWNER_MENU_INDEX: _DOMAIN + 'UPDATE_OWNER_MENU_INDEX',
  GET_FOLLOWED_STATUS_INIT: _DOMAIN + 'GET_FOLLOWED_STATUS_INIT',
  GET_FOLLOWED_STATUS_SUCCESS: _DOMAIN + 'GET_FOLLOWED_STATUS_SUCCESS',
  GET_FOLLOWED_STATUS_FAILURE: _DOMAIN + 'GET_FOLLOWED_STATUS_FAILURE',
  SELECT_VIEW_TYPE: _DOMAIN + 'SELECT_VIEW_TYPE',
  SELECT_SORT: _DOMAIN + 'SELECT_SORT',
  UPDATE_USERS_QUICK_FILTER_OPTIONS: _DOMAIN + 'UPDATE_USERS_QUICK_FILTER_OPTIONS',
  SEARCH: _DOMAIN + 'SEARCH',
  CLEAR: _DOMAIN + 'CLEAR'
};